import { useCallback } from 'react';

import DraggableIcon from 'assets/icons/draggable.svg';
import cn from 'classnames/bind';

import s from './OptionsAnswerButton.module.scss';

const cx = cn.bind(s);

const OptionsAnswerButton = ({
  label,
  value,
  isActive,
  disabled,
  color,
  isDraggable = false,
  onClick,
  className,
  ...attrs
}) => {
  const handleClick = useCallback(() => {
    if (value !== undefined) {
      onClick(value);
    }
  }, [value, onClick]);
  return (
    <button
      className={cx('optionsAnswerButton', 'tp-bold', className, color, { isActive, isDraggable })}
      disabled={disabled}
      onClick={handleClick}
      {...attrs}
    >
      {isDraggable && <DraggableIcon className={cx('draggableIcon')} />}
      {label}
    </button>
  );
};

export default OptionsAnswerButton;
